import Auth from "./Auth";

export default function Register() {
  return (
    <Auth
      mode="signup"
      title="Create Account - MeetHub"
      description="Create your MeetHub account and start professional browser-based meetings in minutes."
      canonicalPath="/register"
    />
  );
}
